wbApp.directive('wbAddressEdit', ['$timeout',
    function ($timeout) {

        return {
            restrict: 'A',
            scope: {
                location: '='
            },
            template: '<ui-gmap-google-map ng-if="mapCenter" center="mapCenter" zoom="mapZoom" control="control" refresh="refresh">' +
                          '<ui-gmap-marker options="markerOptions" coords="markerPos" idkey="0" events="markerEvents" ></ui-gmap-marker>' +
                      '</ui-gmap-google-map>',
            link: function (scope, iElem, attr, controller) {

                var defaultLocation = {
                    longitude: 15.47296200000005200000,
                    latitude: 49.81749199999999000000
                };

                scope.mapZoom = 16;

                scope.markerOptions = {
                    draggable: true,
                    labelContent: "",
                    labelAnchor: "0 0",
                    labelClass: "marker-labels"
                }

                scope.control = {};

                scope.$on('activeTabChanged', function (e, data) {
                    $timeout(function () {
                        scope.control.refresh(scope.mapCenter);
                    },100);
                });

                scope.markerEvents = {
                    dragend: function (marker, eventName, args) {
                        if (marker) {
                            var markerPos = marker.getPosition();
                            if (markerPos) {
                                var lat = markerPos.lat();
                                var lng = markerPos.lng();
                            }
                        }
                        if (!scope.location) {
                            scope.location = {};
                        }

                        scope.location.latitude = lat;
                        scope.location.longitude = lng;
                    }
                }

                scope.$watch('location', function (val) {
                   // console.log(val);
                    if (!val || (!val.longitude && !val.latitude)) {
                        val = defaultLocation;
                        scope.mapZoom = 6;
                    } else {
                        scope.mapZoom = 16;
                    }

                    scope.mapCenter = angular.copy(val);
                    scope.markerPos = angular.copy(val);
                }, true);
            }
        }
    }]);